<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19wrrlK/tc-custom/9780062363169.jpg?1720006962743" alt="This image is the cover for the book Bait, Duty & Honor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bait, Duty & Honor
      </h1>
      <p class="bookDescription body article font2">
        <p><i>In the next thrilling Duty &amp; Honor novel, a female CIA agent and a Delta Force soldier must catch a deadly assassin… but do they know where the danger truly lies?</i></p><p>After several assassination attempts on an allied royal, the CIA sends in operative Christina Madison—who bears a striking resemblance to the monarch—to pose as the famous princess and draw out her would-be killer.</p><p>When Delta Force Lieutenant Gabriel Morgan's team is assigned to Christina's undercover protection detail, he's less than thrilled. Gabe wants nothing to do with a woman whose rumored screw-up nearly got her last team killed. Not to mention there's bad blood between Gabe and the CIA—he doesn't trust anyone who lies for a living.</p><p>But once the trap is set and the assassin takes the bait, Gabe must protect her with his life … because danger lurks in the shadows, and now Christina is in the crosshairs.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leslie Jones
      </h2>
      
      <p class="authorDescription body article"><P><B>Leslie Jones</B> was an Army Intelligence officer for many years and she brings her first-hand experience to the pages of her work. She resides in Scottsdale, Arizona, and is currently hard at work on her next book.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8152a4fa